import DateFilterUtil from '../search/DateFilterUtil';
import { LISTING_TYPE } from '../Localization';
import Export from '../Export';
import Commons from '../Commons';
import { refineValuationConfidence } from '../PropertyAttrFormatter';

const logFalseAsDefaultRange = (eventPropsLabel, filterValue, eventProps) => {
    // logs both min and max value when it has exact value. i.e. 1, 2 3
    // range values should fall under else statement i.e. 1-2, 1-3, 1-
    if (typeof filterValue === 'object'
        && 'min' in filterValue
        && 'max' in filterValue) {
        eventProps.push(
            { label: eventPropsLabel[0], value: filterValue.min || false },
            { label: eventPropsLabel[1], value: filterValue.max || false },
        );
    } else if (filterValue && !filterValue.toString().includes('-')) {
        eventProps.push(
            { label: eventPropsLabel[0], value: filterValue },
            { label: eventPropsLabel[1], value: filterValue },
        );
    } else {
        const values = (filterValue && filterValue !== '') ? `${filterValue}`.split('-') : ['', ''];
        eventProps.push(
            { label: eventPropsLabel[0], value: (!values[0]) ? false : values[0] },
            { label: eventPropsLabel[1], value: (!values[1]) ? false : values[1] }
        );
    }
};

const logFalseAsDefaultRangeHoldPeriod = (eventPropsLabel, filterValue, eventProps) => {
    const formatted = Object.values(filterValue)
        .map(val => val
            ? Export.formatTenureDate(val, 'YYYY/MM/DD')
            : '')
        .reverse()
        .join('-');
    logFalseAsDefaultRange(eventPropsLabel, formatted, eventProps);
};

const logFalseAsDefaultNotRange = (eventPropsLabel, filterValue, eventProps) => {
    eventProps.push({ label: eventPropsLabel, value: (!filterValue) ? false : filterValue });
};

const textFieldProperties = (eventPropsLabel, filterValue, eventProps) => {
    eventProps.push({ label: eventPropsLabel, value: filterValue || false });
};
const landSizeAndPricesProperties = (eventPropsLabel, filterValue, eventProps) => {
    if (typeof filterValue === 'string') {
        const values = (filterValue && `${filterValue}` !== '') ? `${filterValue}`.split('-') : ['', ''];
        eventProps.push({ label: eventPropsLabel[0], value: (values[0] === '') ? false : values[0] });
        if (typeof values[1] !== 'undefined') {
            eventProps.push({ label: eventPropsLabel[1], value: (values[1] === '') ? false : values[1] });
        } else {
            eventProps.push({ label: eventPropsLabel[1], value: values[0] });
        }
    } else {
        eventProps.push(
            { label: eventPropsLabel[0], value: filterValue.min || false },
            { label: eventPropsLabel[1], value: filterValue.max || false },
        );
    }
};
const areaProperties = (eventPropsLabel, filterValue, eventProps) => {
    const getValue = (value) => (value === '') ? false : value;
    eventProps.push({
        label: eventPropsLabel[0],
        value: getValue(filterValue?.min),
    });
    eventProps.push({
        label: eventPropsLabel[1],
        value: getValue(filterValue?.max),
    });
    eventProps.push({
        label: eventPropsLabel[2],
        value: getValue(filterValue?.unit) || 'm²',
    });
};

const multiSelectionFilterProperties = (eventPropsLabel, filterValue, eventProps) => {
    const selectedOptions = !filterValue
      ? ['ANY']
      : JSON.parse(JSON.stringify(`[${filterValue.replace('\\', '\\u0022')}]`));
    eventProps.push({ label: eventPropsLabel, value: selectedOptions });
};

const valuationConfidenceFilterProperties = (eventPropsLabel, filterValue, eventProps) => {
    const selectedOptions = !filterValue ? ['ANY'] : JSON.parse(`[${filterValue.replace('\\', '\\u0022')}]`);
    const refinedOptions = selectedOptions.map(option => refineValuationConfidence(option));
    eventProps.push({ label: eventPropsLabel, value: refinedOptions });
}

const listingType = (eventPropsLabel, filterValue, eventProps) => {
    const listingTypeMethod = LISTING_TYPE;
    const listingTypesList =
        filterValue && filterValue !== '' ?
            `${filterValue}`
                .split(',')
                .map(type =>
                    Object
                        .keys(listingTypeMethod)
                        .find(key => listingTypeMethod[key] === type)) : 'ALL';
    eventProps.push({ label: eventPropsLabel, value: listingTypesList });
};

const dateFilterProperties = (eventPropsLabel, filterValue, eventProps) => {
    if (filterValue
        && filterValue !== ''
        && typeof filterValue === 'string') {
        const formattedDateRangeString = DateFilterUtil
            .dateFilterInitialValue({ value: filterValue });
        const valueArray = `${formattedDateRangeString}`.split('-');
        eventProps.push(
            {
                label: eventPropsLabel[0],
                value: `${(valueArray[0]).trim()}`,
            },
            {
                label: eventPropsLabel[1],
                value: `${(valueArray[1]).trim()}`,
            },
        );
    } else if (filterValue?.min && filterValue?.max) {
        eventProps.push(
            {
                label: eventPropsLabel[0],
                value: Commons.formatDate(filterValue.min?.trim(), 'DD MMM YYYY'),
            },
            {
                label: eventPropsLabel[1],
                value: Commons.formatDate(filterValue.max?.trim(), 'DD MMM YYYY'),
            },
        );
    } else {
        eventProps.push(
            {
                label: eventPropsLabel[0],
                value: false,
            },
            {
                label: eventPropsLabel[1],
                value: false,
            },
        );
    }
};

const withDefaultProperties = (eventPropsLabel, filterValue, eventProps, defaultValue) => {
    eventProps.push({
        label: eventPropsLabel,
        value: filterValue || defaultValue,
    });
};

const domFilterProperties = (eventPropsLabel, filterValue, eventProps) => {
    eventProps.push({
        label: eventPropsLabel,
        value: `${filterValue}+ days`,
    });
};

const propertyType = (eventPropsLabel, filterValue, eventProps) => {
    const propertyTypes = `${filterValue}`.split(',').map((pType) => {
        if (pType === 'Storage_Unit') {
            return pType.replace('_', ' ').toUpperCase();
        }
        if (pType.toLowerCase() === 'all' || pType === '') {
            return 'ANY';
        }
        return pType.toUpperCase();
    });
    eventProps.push({
        label: eventPropsLabel,
        value: propertyTypes,
    });
};

const propertiesForArrayValues = (eventPropsLabel, filterValue, eventProps) => {
    eventProps.push({ label: eventPropsLabel, value: filterValue?.length > 0 && filterValue });
};

const logOnTrueFalseValue = (eventPropsLabel, filterValue, eventProps) => {
    eventProps.push({ label: eventPropsLabel, value: !!filterValue });

};

const constructMixpanelEventBuilder = (label, construct) => ({
    label,
    construct,
});

const constructMixpanelEventBuilderLogOnTrueFalse = (label) =>
    constructMixpanelEventBuilder(label, logOnTrueFalseValue);

const constructMixpanelEventBuilderLandSizeAndPricesProperties = (label) =>
    constructMixpanelEventBuilder(label, landSizeAndPricesProperties);

const constructMixpanelEventBuilderAreaProperties = (label) =>
    constructMixpanelEventBuilder(label, areaProperties);

const constructMixpanelEventBuilderLogFalseAsDefaultNotRange = (label) =>
    constructMixpanelEventBuilder(label, logFalseAsDefaultNotRange);

const constructMixpanelEventBuilderLogFalseAsDefaultRange = (label) =>
    constructMixpanelEventBuilder(label, logFalseAsDefaultRange);

const constructMixpanelEventBuilderTextFieldProperties = (label) =>
    constructMixpanelEventBuilder(label, textFieldProperties);

export default {
    logFalseAsDefaultRange,
    logFalseAsDefaultNotRange,
    landSizeAndPricesProperties,
    multiSelectionFilterProperties,
    valuationConfidenceFilterProperties,
    listingType,
    dateFilterProperties,
    withDefaultProperties,
    domFilterProperties,
    propertyType,
    propertiesForArrayValues,
    logOnTrueFalseValue,
    textFieldProperties,
    constructMixpanelEventBuilder,
    constructMixpanelEventBuilderLogOnTrueFalse,
    constructMixpanelEventBuilderLandSizeAndPricesProperties,
    constructMixpanelEventBuilderLogFalseAsDefaultNotRange,
    constructMixpanelEventBuilderLogFalseAsDefaultRange,
    constructMixpanelEventBuilderTextFieldProperties,
    constructMixpanelEventBuilderAreaProperties,
    logFalseAsDefaultRangeHoldPeriod,
};
